import React, {useEffect} from 'react'
import styled from 'styled-components'
import VideoModal from '../Pages/homePage/Components/VideoModal'
import "./Backdrop.css"

const Backdrop = ({ setShowModal }) => {

    const height = document.getElementById('root').clientHeight
    const width = document.getElementById('root').clientWidth

    let top = document.getElementById('aboutus').offsetTop
    top = top + document.getElementById('videoModal').offsetTop

    return (
        <React.Fragment>
            <VideoModal top={top} />
            <div className="BackdropWrapper" height={height} width={width} onClick={() => setShowModal(false)}>
            </div>
        </React.Fragment>
    )
}



export default Backdrop
